var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
import { FormActions } from '../../enums/workload/form-actions';
var FormActionPipe = /** @class */ (function () {
    function FormActionPipe() {
    }
    FormActionPipe.prototype.transform = function (formAction) {
        switch (formAction) {
            case (FormActions.NotSet):
                {
                    return 'Not Set';
                }
            case (FormActions.NewBuild):
                {
                    return 'Build on Primary and Secondary';
                }
            case (FormActions.CertifiedBuild):
                {
                    return 'Clone on Primary, Build on Secondary';
                }
            case (FormActions.Amendment):
                {
                    return 'Changes to existing qual';
                }
        }
    };
    FormActionPipe = __decorate([
        Pipe({ name: 'formAction' })
    ], FormActionPipe);
    return FormActionPipe;
}());
export { FormActionPipe };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1hY3Rpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZm9ybS1hY3Rpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLE9BQU8sRUFBRSxJQUFJLEVBQWlCLE1BQU0sZUFBZSxDQUFDO0FBRXBELE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxtQ0FBbUMsQ0FBQztBQUdoRTtJQUFBO0lBcUJBLENBQUM7SUFwQlUsa0NBQVMsR0FBaEIsVUFBaUIsVUFBdUI7UUFDcEMsUUFBUSxVQUFVLEVBQUU7WUFDaEIsS0FBSyxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUM7Z0JBQ3pCO29CQUNJLE9BQU8sU0FBUyxDQUFDO2lCQUNwQjtZQUNELEtBQUssQ0FBQyxXQUFXLENBQUMsUUFBUSxDQUFDO2dCQUMzQjtvQkFDSSxPQUFPLGdDQUFnQyxDQUFDO2lCQUMzQztZQUNELEtBQUssQ0FBQyxXQUFXLENBQUMsY0FBYyxDQUFDO2dCQUNqQztvQkFDSSxPQUFPLHNDQUFzQyxDQUFDO2lCQUNqRDtZQUNELEtBQUssQ0FBQyxXQUFXLENBQUMsU0FBUyxDQUFDO2dCQUM1QjtvQkFDSSxPQUFPLDBCQUEwQixDQUFDO2lCQUNyQztTQUNKO0lBQ0wsQ0FBQztJQXBCUSxjQUFjO1FBRDFCLElBQUksQ0FBQyxFQUFFLElBQUksRUFBRSxZQUFZLEVBQUUsQ0FBQztPQUNoQixjQUFjLENBcUIxQjtJQUFELHFCQUFDO0NBQUEsQUFyQkQsSUFxQkM7U0FyQlksY0FBYyJ9